import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=a765a1f8&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=a765a1f8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a765a1f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a765a1f8')) {
      api.createRecord('a765a1f8', component.options)
    } else {
      api.reload('a765a1f8', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=a765a1f8&scoped=true&", function () {
      api.rerender('a765a1f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4HcUgo3SGCQfw/JS/comp/Paginate.vue"
export default component.exports